// ==============================|| AUTHX THEME - PALETTE ||============================== //
// Brand: AuthX teal (#186478) + orange accent (#EF8C14), neutral grey scale, soft semantic colours.

const BRAND = {
  lighter: '#E8F3F6',
  100: '#CFE6EC',
  200: '#A6D0DB',
  light: '#5BA3B5',
  400: '#357F94',
  main: '#186478',
  dark: '#0F4F60',
  700: '#0C4252',
  darker: '#093644',
  900: '#062933',
  contrastText: '#FFFFFF'
};

export default function Default(colors) {
  const { red, gold, cyan, green, grey } = colors;
  const greyColors = {
    0: grey[0],
    50: grey[1],
    100: grey[2],
    200: grey[3],
    300: grey[4],
    400: grey[5],
    500: grey[6],
    600: grey[7],
    700: grey[8],
    800: grey[9],
    900: grey[10],
    A50: grey[15],
    A100: grey[11],
    A200: grey[12],
    A400: grey[13],
    A700: grey[14],
    A800: grey[16]
  };
  const contrastText = '#fff';

  return {
    primary: BRAND,
    // the orange of the AuthX logo – used for highlights, badges and "attention" actions
    accent: {
      lighter: '#FFF4E5',
      light: '#F7B15C',
      main: '#EF8C14',
      dark: '#C2700C',
      darker: '#8F5209',
      contrastText: '#FFFFFF'
    },
    secondary: {
      lighter: greyColors[100],
      100: greyColors[100],
      200: greyColors[200],
      light: greyColors[300],
      400: greyColors[400],
      main: greyColors[500],
      600: greyColors[600],
      dark: greyColors[700],
      800: greyColors[800],
      darker: greyColors[900],
      A100: greyColors[0],
      A200: greyColors.A400,
      A300: greyColors.A700,
      contrastText: greyColors[0]
    },
    error: {
      lighter: '#FEF3F2',
      light: '#FDA29B',
      main: '#D92D20',
      dark: '#B42318',
      darker: '#7A271A',
      contrastText
    },
    warning: {
      lighter: '#FFFAEB',
      light: '#FEC84B',
      main: '#F79009',
      dark: '#B54708',
      darker: '#7A2E0E',
      contrastText: '#fff'
    },
    info: {
      lighter: cyan[0],
      light: cyan[3],
      main: cyan[5],
      dark: cyan[7],
      darker: cyan[9],
      contrastText
    },
    success: {
      lighter: '#ECFDF3',
      light: '#6CE9A6',
      main: '#12B76A',
      dark: '#027A48',
      darker: '#054F31',
      contrastText
    },
    grey: greyColors
  };
}
